import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import {
  fetchLiveAvailability,
  selectLiveAvailability,
  selectLiveAvailabilityLoading,
  OCCUPANCY_TYPE_CHOICES
} from 'ducks/occupancy';

import Loader from 'components/Loader';

import {getCurrentDayMonthAndYear} from 'utils/datetime';

import './styles.css';

const Section = ({isLoading, value, title}) => (
  <div className="section colab-centered">
    <div className="value">
      {isLoading && <Loader />}
      {!isLoading && value}
    </div>
    <div className="title">{title}</div>
  </div>
);

class LiveAvailabilitySection extends React.Component<any> {
  componentDidMount() {
    this.props.fetchLiveAvailability({
      locationRef: this.props.locationRef
    });
  }

  render() {
    const {
      isLoading,
      activeTab,
      liveAvailabilityData: {
        available,
        booked,
        physicalBooked,
        outOfOrder,
        arrivals,
        departures,
        total
      }
    } = this.props;
    let occupancy = Math.round(booked / total * 100) || 0;
    let bookedValue = booked;
    let bookedTitle = 'Booked';

    if (activeTab === OCCUPANCY_TYPE_CHOICES.PHYSICAL_OCCUPANCY) {
      occupancy = Math.round(physicalBooked / total * 100) || 0;
      bookedValue = physicalBooked;
      bookedTitle = 'Confirmed and Reserved';
    }

    return (
      <div className="LiveAvailabilitySection colab-medium-border-radius">
        <div className="heading">
          <div className="colab-heading">Live Availability</div>
          <div className="LiveAvailabilitySection__subheading">
            {getCurrentDayMonthAndYear()}
          </div>
        </div>
        <div className="info colab-row-space-between">
          <Section
            isLoading={isLoading}
            value={`${occupancy}%`}
            title="Occupancy"
          />
          <Section isLoading={isLoading} value={available} title="Available" />
          <Section
            isLoading={isLoading}
            value={bookedValue}
            title={bookedTitle}
          />
          <Section
            isLoading={isLoading}
            value={outOfOrder}
            title="Out of order"
          />
          <Section isLoading={isLoading} value={arrivals} title="Arrivals" />
          <Section
            isLoading={isLoading}
            value={departures}
            title="Departures"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: selectLiveAvailabilityLoading(state),
  liveAvailabilityData: selectLiveAvailability(state)
});

const mapDispatchToProps = {fetchLiveAvailability};

export default connect(mapStateToProps, mapDispatchToProps)(
  LiveAvailabilitySection
);
